'use client';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import SectionHeadMore from './SectionHeadMore';
import BlogCard from './BlogCard';
import Api from '@/api';
import { Blog } from '@/commonTypes';
import { mapBlog } from '@/functions/mapApiData';

export default function SampleBlogs({
  title = 'آخرین مطالب و راهنماها',
  tag = 'مجلهٔ کارا',
  all = 'مشاهدهٔ همهٔ مقالات',
  href = '/blogs',
  className = '',
  brandId,
  groupSlug,
  tagSlug,
  limit = 3,
}: {
  title?: string;
  tag?: string | undefined;
  href?: string;
  className?: string;
  brandId?: string | number | null;
  groupSlug?: string | number | null;
  tagSlug?: string | number | null;
  limit?: number;
}) {
  const [posts, setPosts] = useState<Blog[]>([]);

  useEffect(() => {
    const params: any = { start: 0, limit };
    if (brandId) params.brand_id = brandId;
    if (groupSlug) params.group_slug = groupSlug;
    if (tagSlug) params.tag_slug = tagSlug;

    Api.blogList({ params })
      .then((res: any) => {
        const response = res?.data?.response || [];
        setPosts(response.map(mapBlog));
      })
      .catch((err) => {
        console.error('blogList failed:', err);
        setPosts([]);
      });
  }, [brandId, groupSlug, tagSlug, limit]);

  if (posts.length === 0) {
    return null;
  }

  return (
    <section className={`${styles.section} ${className}`}>
      <div className={styles.inner}>
        <SectionHeadMore
          item={{ kicker: tag, title, all }}
          href={href}
          titleClass={styles.titleClass}
        />

        <div className={`grid_3`}>
          {posts.map((b, index) => (
            <BlogCard key={b.id ?? index} item={b} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
